export default __webpack_public_path__ + "static/media/copy_disable.135da246.svg";